module.exports = __webpack_public_path__ + "static/media/endBanner.5e1562ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/endBanner.png
// module id = 659
// module chunks = 0